import React from "react";

export const LogoMark = ({ size = 28 }) => (
  <svg
    width={size}
    height={size * (24 / 28)}
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="logo-mark"
    style={{ display: "block" }}
  >
    {/* Left bracket */}
    <path
      d="M5 3 L2 3 L2 21 L5 21"
      stroke="#185FA5"
      strokeWidth="2.2"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      fill="none"
    />
    {/* Right bracket */}
    <path
      d="M23 3 L26 3 L26 21 L23 21"
      stroke="#185FA5"
      strokeWidth="2.2"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      fill="none"
    />
    {/* Outer ring */}
    <circle cx="14" cy="12" r="9.5" stroke="#185FA5" strokeOpacity="0.22" strokeWidth="1.2" fill="none" />
    {/* Middle ring */}
    <circle cx="14" cy="12" r="5.8" stroke="#185FA5" strokeOpacity="0.55" strokeWidth="1.2" fill="none" />
    {/* Inner ring */}
    <circle cx="14" cy="12" r="2.8" stroke="#185FA5" strokeOpacity="0.9" strokeWidth="1.2" fill="none" />
    {/* Center dot */}
    <circle cx="14" cy="12" r="1.4" fill="#185FA5" />
  </svg>
);

export const Wordmark = ({ tagline = true }) => (
  <div className="flex flex-col leading-none wordmark" data-testid="logo-wordmark">
    <div
      style={{
        fontFamily: "Syne, sans-serif",
        fontWeight: 800,
        letterSpacing: "2px",
        fontSize: "15px",
      }}
    >
      <span className="wordmark-sit" style={{ color: "var(--text, #f0f2f8)" }}>SIT</span>
      <span style={{ color: "var(--blue, #185FA5)" }}>ROOM</span>
    </div>
    {tagline && (
      <div
        style={{
          fontFamily: "DM Mono, monospace",
          fontSize: "8px",
          letterSpacing: "3px",
          color: "#636880",
          marginTop: "3px",
        }}
      >
        ONE ROOM. ZERO SURPRISES.
      </div>
    )}
  </div>
);
